import React, { useState, useEffect } from 'react';
import {
  Typography,
  Form,
  Input,
  Row,
  Col,
  Radio,
  notification,
  Space,
  Descriptions,
  Skeleton,
  Layout,
} from 'antd';
import { useQuery } from '../../../utils/helpers/helpers';

import CustomButton from '../../../components/CustomButton';
import CustomUpload from '../../../components/CustomUpload';
import INTERNAL_LINKS from '../../../enums/InternalLinks';
import MESSAGES from '../../../enums/Messages';
import BreadcrumbContainer from '../../../containers/Breadcrumb';
import { get } from '../../../api/module/announcement_preselection';
import {
  post,
  postDocument,
} from '../../../api/module/announcement_preselection_email';

const { Title, Text } = Typography;
const { TextArea } = Input;
const { Content } = Layout;

const AnnouncementEmail = ({ history, match }) => {
  const [loading, setLoading] = useState();
  const [documento, setDocumento] = useState(false);
  const [loadingForm, setLoadingForm] = useState(true);
  const [initialValues, setInitialValues] = useState(null);
  const [formData] = useState(new FormData());
  let query = useQuery();

  const email = query.get('email');

  const onChange = (e) => {
    setDocumento(e.target.value);
  };

  const onFinish = async (data) => {
    try {
      let status = 0;
      setLoading(true);
      if (email === 'preselected') {
        status = 11;
      }
      if (email === 'adjust-information') {
        status = 12;
      }
      if (email === 'rejected') {
        status = 13;
      }
      let response;
      data.convocatoria_tercero = match.params.preselection_id;
      data.convocatoria = match.params.announcement_id;
      data.estado_tercero = status;
      if (documento) {
        data.archivo_carta_compromiso =
          data.archivo_carta_compromiso.fileList[0].originFileObj;
        formData.append('archivo_carta_compromiso', data);
        for (let prop in data) {
          if (data.hasOwnProperty(prop)) formData.append(prop, data[prop]);
        }
        response = await postDocument(formData);
      } else {
        response = await post(data);
      }
      if ([200, 201, 204].indexOf(response.status) > -1) {
        notification.success({
          message: MESSAGES.SUCCESS_MSG,
          description: MESSAGES.DESC_SUCCESS_MSG,
          duration: 2,
        });
        setTimeout(() => {
          history.push(
            `${INTERNAL_LINKS.ANNOUNCEMENT_PRESELECTION_VALIDATION}/${match.params.announcement_id}/${match.params.announcement_rol_id}`,
          );
          setLoading(false);
        }, MESSAGES.TIME);
      }
    } catch (err) {
      console.log(err);
      notification.error({
        message: MESSAGES.ERROR_MSG,
        description: MESSAGES.DESC_ERROR_POST_MSG,
        duration: 2,
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    getPreselection();
  }, []);

  const getPreselection = async () => {
    const response = await get(match.params.preselection_id);
    setInitialValues(response.data);
    setLoadingForm(false);
  };

  const breadcrumbItems = [
    {
      text: 'Preseleccionados',
      to: `${INTERNAL_LINKS.ANNOUNCEMENT_PRESELECTION}`,
    },
    {
      text: 'Validación',
      to: `${INTERNAL_LINKS.ANNOUNCEMENT_PRESELECTION_VALIDATION}/${match.params.announcement_id}/${match.params.announcement_rol_id}`,
    },
    {
      text: 'Generar Email',
    },
  ];

  const state = () => {
    if (email === 'preselected') {
      return 'Preseleccionado';
    }
    if (email === 'adjust-information') {
      return 'Ajustar información';
    }
    if (email === 'rejected') {
      return 'Rechazado';
    }
  };

  const back = () => {
    history.push(
      `${INTERNAL_LINKS.ANNOUNCEMENT_PRESELECTION_VALIDATION}/${match.params.announcement_id}/${match.params.announcement_rol_id}`,
    );
  };

  return (
    <Content>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Skeleton loading={loadingForm} active>
        {initialValues != null && (
          <Space
            direction={'vertical'}
            style={{ width: '100%' }}
            size={'middle'}
          >
            <Title className={'text-uppercase'} level={2}>
              Módulo de Preselección
            </Title>
            <Descriptions column={1} bordered>
              <Descriptions.Item label="Estado">{state()}</Descriptions.Item>
              <Descriptions.Item label="Nombres">
                {initialValues.nombres_apellidos}
              </Descriptions.Item>
            </Descriptions>
            <Descriptions title="Observaciones" column={1} bordered>
              {initialValues.tipo_persona === 1 ? (
                <>
                  <Descriptions.Item label="Observación general Educación">
                    {initialValues.observacion_educacion}
                  </Descriptions.Item>
                  <Descriptions.Item label="Observación general Experiencia">
                    {initialValues.observacion_experiencia}
                  </Descriptions.Item>
                </>
              ) : (
                <Descriptions.Item label="Observación general Documentos">
                  {initialValues.observacion_documentos}
                </Descriptions.Item>
              )}
            </Descriptions>
            <Form
              onFinish={onFinish}
              initialValues={initialValues}
              layout="vertical"
            >
              <Form.Item
                name="mensaje"
                label={<Text strong>Mensaje del correo</Text>}
              >
                <TextArea rows={4} />
              </Form.Item>
              {state() === 'Preseleccionado' && (
                <Row gutter={12}>
                  <Col span={12}>
                    <Form.Item
                      name="carta_compromiso"
                      label={<Text strong>¿Enviar carta de compromiso?</Text>}
                      rules={[
                        {
                          required: true,
                        },
                      ]}
                    >
                      <Radio.Group onChange={onChange}>
                        <Radio value={true}>Sí</Radio>
                        <Radio value={false}>No</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    {documento && (
                      <CustomUpload
                        name="archivo_carta_compromiso"
                        file_type={1}
                        upload_type={2}
                      />
                    )}
                  </Col>
                </Row>
              )}
              <Space>
                <CustomButton loading={loading} text="Enviar correo" />
                <CustomButton
                  type={'default'}
                  className={'back-button'}
                  htmlType="button"
                  onClick={back}
                  text="Volver"
                />
              </Space>
            </Form>
          </Space>
        )}
      </Skeleton>
    </Content>
  );
};

export default AnnouncementEmail;
